import { Api } from "./config/request";

export const getCountryList = () => {
  return Api.getRequest(`miscallaneous/countries/`);
};

export const Country = {
  getCountryList
};
